import { Name } from "@omni/ui/components/Product/Feature/KeyFeatures/components/feature/components/name";
import { Value } from "@omni/ui/components/Product/Feature/KeyFeatures/components/feature/components/value";
import { Base } from "@omni/ui/components/Product/Feature/KeyFeatures/components/feature/feature.base";

import { useFeatureContext } from "@/components/Product/Feature/KeyFeatures/components/feature/context/feature.context";

export const Feature = Object.assign(Base, {
    useContext: useFeatureContext,
    Name: Name,
    Value: Value
});
